import { useState } from 'react';
import { DialogContent, IconButton, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useModalHistory } from '../utils/useModalHistory';
import { APP_LABELS } from '../utils/labels';
import AppDialog from './AppDialog';

interface InfoDialogProps {
  title: string;
  description: string;
  onClose: () => void;
}

function InfoDialog({ title, description, onClose }: InfoDialogProps) {
  useModalHistory(onClose);
  return (
    <AppDialog open onClose={onClose} fullScreenOnMobile={false} title={title}>
      <DialogContent>
        {description.split('\n\n').map((paragraph, i) => (
          <p key={i} className="mt-0 mb-3 last:mb-0">{paragraph}</p>
        ))}
      </DialogContent>
    </AppDialog>
  );
}

interface InfoButtonProps {
  title: string;
  description: string;
  className?: string;
}

export default function InfoButton({ title, description, className }: InfoButtonProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Tooltip title={APP_LABELS.infoButton}>
        <IconButton
          onClick={() => setOpen(true)}
          aria-label={APP_LABELS.infoButton}
          size="small"
          className={className}
          color="inherit"
        >
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      {open && <InfoDialog title={title} description={description} onClose={() => setOpen(false)} />}
    </>
  );
}
